import { render, staticRenderFns } from "./RealTimeData.vue?vue&type=template&id=ecd52bbe&scoped=true"
import script from "./RealTimeData.vue?vue&type=script&lang=js"
export * from "./RealTimeData.vue?vue&type=script&lang=js"
import style0 from "./RealTimeData.vue?vue&type=style&index=0&id=ecd52bbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd52bbe",
  null
  
)

export default component.exports